import { APIClient } from "./axiosClient";
const api = new APIClient();

const path = "viewed-resumes";

const resumeViewLogApi = {
  viewResumeLogs(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
};

export default resumeViewLogApi;
